import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface FirmIdFieldProps {
  name: string;
  id: string;
}

export function FirmIdField({ name, id }: FirmIdFieldProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      inputSize="medium"
      blockWidth
      label="Firm ID"
      disabled
    />
  );
}
